import { Injectable, inject } from '@angular/core';
import { AbstractControl, FormGroup, UntypedFormControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { UserRepository } from '../state/user/user.repository';

interface ValidationError {
  [s: string]: boolean;
}

@Injectable({
  providedIn: 'root',
})
export class FormValidatorsService {
  private readonly userRepo = inject(UserRepository);

  constructor() {
    sessionStorage.setItem('userName', this.userRepo.getNickName());
  }

  userNameValidator(control: UntypedFormControl): ValidationError {
    if (control.value !== sessionStorage.getItem('userName')) {
      return { invalidUserName: true };
    }

    return null;
  }

  touchAllControls(form: FormGroup) {
    Object.values(form.controls).forEach((control) => {
      control.markAsTouched();
    });
  }

  validateControl(name: string, form: FormGroup): boolean {
    return form.get(name).invalid && form.get(name).touched;
  }

  passwordMatchValidator(password: string, confirmPassword: string): ValidatorFn {
    return (formGroup: AbstractControl): ValidationErrors | null => {
      const passwordControl = formGroup.get(password);
      const confirmPasswordControl = formGroup.get(confirmPassword);

      if (!passwordControl || !confirmPasswordControl) {
        return null;
      }

      const isMatching = passwordControl.value === confirmPasswordControl.value;

      return isMatching ? null : { passwordMismatch: true };
    };
  }
}
